// extracted by mini-css-extract-plugin
module.exports = {"screen":"ModalWS_screen__3ozmV","window":"ModalWS_window__3vUl8"};